import type { ReactNode } from 'react'
import { AUTH_MODE } from './AuthContext'
import { Auth0AuthProvider } from './Auth0AuthProvider'
import { BypassAuthProvider } from './BypassAuthProvider'

/**
 * One switch, read once at module load. Everything downstream consumes
 * `useAuth()` and never asks which mode it is in — except the two login
 * screens, where the *user-visible* flow genuinely differs.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  if (AUTH_MODE === 'auth0') return <Auth0AuthProvider>{children}</Auth0AuthProvider>
  return <BypassAuthProvider>{children}</BypassAuthProvider>
}
